// draggableNode.js

const NODE_COLORS = {
  customInput: { bg: '#EFF6FF', border: '#BFDBFE', color: '#1D4ED8', label: 'IN' },
  customOutput: { bg: '#F0FDF4', border: '#BBF7D0', color: '#15803D', label: 'OUT' },
  llm:          { bg: '#FAF5FF', border: '#E9D5FF', color: '#7E22CE', label: 'AI' },
  text:         { bg: '#FFF7ED', border: '#FED7AA', color: '#C2410C', label: 'T' },
  filter:       { bg: '#FEFCE8', border: '#FEF08A', color: '#A16207', label: 'FT' },
  note:         { bg: '#F8FAFC', border: '#E2E8F0', color: '#475569', label: '✎' },
  //math:         { bg: '#F0FDF4', border: '#BBF7D0', color: '#15803D', label: '∑' },
  // Math — change to indigo
  math: { bg: '#EEF2FF', border: '#C7D2FE', color: '#4338CA', label: '∑' },
  timer:        { bg: '#FFF1F2', border: '#FECDD3', color: '#BE123C', label: '⏱' },
  // api:          { bg: '#ECFDF5', border: '#A7F3D0', color: '#065F46', label: 'API' },
  api: { bg: '#ECFEFF', border: '#A5F3FC', color: '#0E7490', label: 'API' },
};

const DEFAULT_COLOR = { bg: '#F8FAFC', border: '#E2E8F0', color: '#475569', label: '?' };

export const DraggableNode = ({ type, label }) => {
  const theme = NODE_COLORS[type] || DEFAULT_COLOR;

  const onDragStart = (event, nodeType) => {
    const appData = { nodeType };
    event.target.style.cursor = 'grabbing';
    event.dataTransfer.setData('application/reactflow', JSON.stringify(appData));
    event.dataTransfer.effectAllowed = 'move';
  };

  return (
    <div
      className={type}
      onDragStart={(event) => onDragStart(event, type)}
      onDragEnd={(event) => (event.target.style.cursor = 'grab')}
      draggable
      style={{
        cursor: 'grab',
        minWidth: '120px',
        height: '64px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
        gap: '4px',
        borderRadius: '10px',
        backgroundColor: theme.bg,
        border: `1.5px solid ${theme.border}`,
        padding: '0 12px',
        transition: 'transform 0.15s, box-shadow 0.15s',
        boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
        userSelect: 'none',
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = 'translateY(-2px)';
        e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.1)';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = 'translateY(0)';
        e.currentTarget.style.boxShadow = '0 1px 3px rgba(0,0,0,0.06)';
      }}
    >
      {/* Icon badge */}
      <div
        style={{
          fontSize: 10,
          fontWeight: 700,
          color: theme.color,
          background: theme.border,
          borderRadius: 4,
          padding: '1px 5px',
          letterSpacing: '0.03em',
        }}
      >
        {theme.label}
      </div>

      {/* Label */}
      <span
        style={{
          fontSize: 12,
          fontWeight: 600,
          color: theme.color,
          letterSpacing: '0.01em',
        }}
      >
        {label}
      </span>
    </div>
  );
};